import { ref } from 'vue';

const pakHo = ref({ data: null });

export function usePakHo() {
  // 鼠标在图表上移动时，触发的回调
  const crossHairMove = (data) => {
    pakHo.value = { data };
  };

  return {
    pakHo,
    crossHairMove
  };
}
